import { Input, DatePicker, Radio, Select, Space, TimePicker } from "antd";
import { useEffect, useState } from "react";
import { Label } from "reactstrap";
import dayjs from "dayjs";
import { post_api } from "api";
import { toast } from "react-toastify";
import { put_api } from "api";
import { debounce, pick } from "lodash";
import { ReactComponent as CustomArrowIcon } from "../../assets/img/dropdown-icon.svg";
import { unPaidHoursList } from "components/GeneralComponents/Utils";
import { useNavigate } from "react-router-dom";
import { get_api } from "api";
import { USER_ROLE } from "variables/helper";

const usePostShiftHook = (
    openPostShiftModal,
    setOpenPostShiftModal,
    refreshShifts
) => {
    const navigate = useNavigate();
    const [current, setCurrent] = useState(0);
    const [loading, setLoading] = useState(false);
    const [errorsVisible, setErrorsVisible] = useState(false);
    const [availableLocation, setAvailableLocation] = useState([]);
    const [hasPostShiftObj, setHasPostShiftObj] = useState(false);
    const [postShiftObj, setPostShiftObj] = useState({
        date: null,
        addDates: [],
        start_time: null,
        end_time: null,
        hourly_rate_type: "Fixed",
        unpaid_hours: null,
        hourly_rate: null,
        isPosted: false,
        location: null,
        role:
            JSON.parse(localStorage.getItem("user"))?.role === "user"
                ? "user"
                : "subuser",
    });
    const [shiftExists, setShiftExists] = useState(false);
    const [shiftOverview, setShiftOverview] = useState({});
    
    const next = () => {
        setCurrent(current + 1);
        setErrorsVisible(false);
    };

    const prev = () => {
        setCurrent(current - 1);
        setErrorsVisible(false);
    };

    const skip = () => {
        setCurrent(current + 1);
        setErrorsVisible(false);
    };
    
    const showErrors = () => {
        setErrorsVisible(true);
    };

    const getAllAvailableLocationForSubUser = async () => {
        try {
            setLoading(true);
            const { data, message } = await get_api(
                "multilocation/get-location-of-subuser"
            );
            if (data) {
                if (data.userLocation.length === 1 && JSON.parse(localStorage.getItem("user"))?.role === USER_ROLE.SUB_USER) {
                    setPostShiftObj((prev) => ({
                        ...prev,
                        location: data.userLocation[0]._id,
                    }));
                }
                setAvailableLocation(
                    data.userLocation.map((loc) => {
                        return {
                            value: loc._id,
                            label: loc.location.locationName + " " + loc.location.address,
                        };
                    })
                );
                
                setHasPostShiftObj( true );
            }
            
            console.log("API Message [multilocation/get-location-of-subuser]: ", message);
            setLoading(false);
        } catch (err) {
            toast.error(err.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (JSON.parse(localStorage.getItem("user")) !== null && false === hasPostShiftObj) {
            getAllAvailableLocationForSubUser();
        }
        if (availableLocation.length === 1 && JSON.parse(localStorage.getItem("user"))?.role === USER_ROLE.SUB_USER) {
            setPostShiftObj((prev) => ({
                ...prev,
                location: availableLocation[0].value,
            }));
        }
    }, [openPostShiftModal, availableLocation, hasPostShiftObj]);

    const resetStates = () => {
        setOpenPostShiftModal && setOpenPostShiftModal(false);
        setPostShiftObj({
            date: null,
            addDates: [],
            start_time: null,
            end_time: null,
            hourly_rate_type: "Fixed",
            unpaid_hours: null,
            hourly_rate: null,
            isPosted: false,
            location: null,
            role:
                JSON.parse(localStorage.getItem("user"))?.role === "user"
                    ? "user"
                    : "subuser",
        });
        setShiftOverview({});
        setCurrent(0);
    };
    function convertDateFormat(dateStr, format) {
        const date = dayjs(dateStr);

        if (date && date.isValid()) {
            if (format === "DD-MM-YYYY") {
                const date = dayjs(dateStr, "YYYY-MM-DD");
                return date.format("DD-MM-YYYY");
            } else {
                const date = dayjs(dateStr, "DD-MM-YYYY");
                return date.format("YYYY-MM-DD");
            }
        }
    }
    function dateNextDay(dateStr, currFormat) {
        const date = dayjs(dateStr, currFormat);

        if (date.isValid()) {
            return date.add(1, 'day').format(currFormat);
        }
        return null;
    }
    const createPostShift = async () => {
        try {
            setLoading(true);
            
            const { addDates = [] } = postShiftObj;
            const obj = pick(postShiftObj, [
                "date",
                "start_time",
                "end_time",
                "unpaid_hours",
                "hourly_rate_type",
                "hourly_rate",
                "isPosted",
                "location",
                "role",
            ]);
            if (!obj.location) {
                delete obj.location;
            }
            obj.date = obj.date.split("-").reverse().join("-");
            
            // eslint-disable-next-line no-unused-vars
            const { data, message } = await post_api(
                "post-shifts/create",
                obj
            );
            // clone the object for each addDate and repeat the API call
            const responseData = data.postShiftDetail ?? null;
            const postedSuccess = null !== responseData;
            //console.log( 'Maybe post bulk shifts:', addDates, postedSuccess );
            let addedDates = [];
            if( addDates.length && postedSuccess ){
                // Create each entry sequentially
                for (const dt of addDates) {
                    console.log('Processing bulk shift: ', dt);
                    if( !dt ){
                        continue; // skip invalid or non-set dates
                    }
                    obj.date = dt.split("-").reverse().join("-");
                    try {
                        const { data: subData, message: subMessage } = await post_api(
                            "post-shifts/create",
                            obj
                        );
                        
                        console.log("API Message ("+dt+") [post-shifts/create]: ", subMessage);
                        const postShift = subData.postShiftDetail ?? null;
                        if( null !== postShift ){
                            addedDates.push( postShift );
                        }
                    } catch (err) {
                        toast.error("Error creating Shift ("+dt+"): " + err.message);
                    }
                }
            }
            
            const sendShiftOverview = { ...data, addedDates };
            setShiftOverview(sendShiftOverview);
            setLoading(false);
            console.log("API Message [post-shifts/create]: ", message);
            // toast.success(message);
            refreshShifts();
            return data;
        } catch (err) {
            toast.error("Error creating Shift: " + err.message);
            setLoading(false);
        }
    };

    const updatePostShift = async () => {
        try {
            setLoading(true);
            const psData = postShiftObj?._id
                ? postShiftObj
                : shiftOverview?.postShiftDetail;
            const addDates = postShiftObj?._id
                ? []
                : shiftOverview?.addedDates;

            const obj = pick(psData, [
                "_id",
                "date",
                "start_time",
                "end_time",
                "unpaid_hours",
                "hourly_rate_type",
                "hourly_rate",
                "isPosted",
                "location",
            ]);
            if (postShiftObj?._id) {
                obj.date = psData.date.split("-").reverse().join("-");
            }
            if (typeof psData.location !== "string") {
                obj.location = postShiftObj.location;
            }
            if (!obj.location) {
                delete obj.location;
            }
            console.log('Update Shift obj: ', obj);
            const { data, message } = await put_api("post-shifts/update", {
                ...obj,
                isPosted: true,
            });
            
            // clone the object for each addDate and repeat the API call
            const responseData = data.postShiftDetail ?? null;
            const postedSuccess = null !== responseData;
            //console.log( 'Maybe update bulk shifts:', addDates, postedSuccess );
            if( addDates.length && postedSuccess ){
                // Create each entry sequentially
                for (const dt of addDates) {
                    console.log('Processing bulk shift: ', dt.date);
                    const subObj = pick(dt, [
                        "_id",
                        "date",
                        "start_time",
                        "end_time",
                        "unpaid_hours",
                        "hourly_rate_type",
                        "hourly_rate",
                        "isPosted",
                        "location",
                    ]);
                    if (typeof subObj.location !== "string") {
                        subObj.location = postShiftObj.location;
                    }
                    if (!subObj.location) {
                        delete subObj.location;
                    }
                    try {
                        const { /*data: subData,*/ message: subMessage } = await put_api(
                            "post-shifts/update",
                            {
                                ...subObj,
                                isPosted: true,
                            }
                        );
                        
                        console.log("API Message ("+subObj.date+") [post-shifts/update]: ", subMessage);
                    } catch (err) {
                        toast.error("Error updating Shift ("+subObj.date+"): " + err.message);
                    }
                }
            }
            
            console.log("API Message [post-shifts/update]: ", message);
            toast.success(message);
            resetStates();
            refreshShifts();
            setLoading(false);
            navigate("/post-shifts");
            return data;
        } catch (err) {
            setLoading(false);
            toast.error(err.message);
        }
    };

    const initializeShiftData = (data) => {
        setPostShiftObj({
            date: convertDateFormat(data.date, "DD-MM-YYYY"),
            addDates: [], // Only used on Add Shift (not used on Update/Edit Shift)
            start_time: data.start_time,
            end_time: data.end_time,
            hourly_rate_type: data.hourly_rate_type,
            unpaid_hours: data.unpaid_hours,
            hourly_rate: data.hourly_rate,
            isPosted: data.isPosted,
            location: data?.location?._id || null,
            role: data.role,
            _id: data._id,
        });
        if( data ){
            setShiftExists(true);
        }
    };

    const disabledDate = (current) => {
        const { date = null, addDates = [] } = postShiftObj;
        if( !current ){
            return false;
        }
        const dtStr = convertDateFormat(current, "DD-MM-YYYY");
        return (current < dayjs().startOf("day") || addDates.includes(dtStr) || date === dtStr);
    };
    
    const cellRender = (current, info) => {
        const { date = null, addDates = [] } = postShiftObj;
        if (info.type !== 'date') {
            return info.originNode;
        }
        if (typeof current === 'number' || typeof current === 'string') {
            return <div className="ant-picker-cell-inner">{current}</div>;
        }
        const highlight = {border: `2px solid rgba(2, 58, 40, 0.7)`,borderRadius: '4px',lineHeight: '28px',};
        const dtStr = convertDateFormat(current, "DD-MM-YYYY");
        return (
            <div className="ant-picker-cell-inner TEST123" style={(dtStr === date || addDates.includes(dtStr)) ? highlight : {}}>
                {current.date()}
            </div>
        );
    };

    const handleStartTimeChange = debounce((time, timeString) => {
        const { end_time } = postShiftObj;
        let newPostShiftObj = {
            ...postShiftObj,
            start_time: timeString,
        };
        
        // If End Time becomes invalid (less than a 1hr shift), blank it out
        let forceRecalc = false;
        if( null !== end_time && "" !== end_time ){
            let endTime = dayjs(end_time, "h:mm A");
            endTime = endTime.subtract(1, 'hour');
            if( endTime < time ){
                newPostShiftObj.end_time = null;
                forceRecalc = true;
            }
        }
        
        // If possible, pre-select end time for an 8 hour shift.
        if( null !== time && "" !== time && (null === end_time || "" === end_time || forceRecalc) ){
            const startHour = time.hour();
            if( startHour < 16 ){ // only possible if starting before 4:00PM
                let endTime = dayjs(timeString, "h:mm A");
                endTime = endTime.add(8, 'hour');
                newPostShiftObj.end_time = endTime.format("h:mm A");
            }
        }
        
        setPostShiftObj(newPostShiftObj);
    }, 300);
    
    // Prevent the user from selecting an End Time that is less than 1 hour
    // (only works on PM shifts though, because hour/minute needs to be selected before AM/PM toggle)
    const getDisabledEndHours = (time) => {
        const disabledHours = [];
        const { start_time } = postShiftObj;
        if( null == start_time ){
            return disabledHours;
        }
        const unAvailableTime = dayjs(start_time, "h:mm A");
        // Enforce a minimum shift length of 1 hour
        const startHour = unAvailableTime.hour();
        // only apply for PM start shifts, as this blocks selecting the PM version (eg. 9AM blocks 1-8PM)
        if( startHour >= 12 ){
            for( let h=0; h <= startHour; h++ ){
                disabledHours.push(h);
            }
        }
        
        
        return disabledHours;
    };
    
    // Prevent the user from selecting an End Time that is less than 1 hour
    const getDisabledEndMinutes = (time, selectedHour) => {
        const disabledMinutes = [];
        const { start_time } = postShiftObj;
        if( null == start_time ){
            return disabledMinutes;
        }
        let unAvailableTime = dayjs(start_time, "h:mm A");
        // Enforce a minimum shift length of 1 hour
        unAvailableTime = unAvailableTime.add(1,'hour');
        const startHour = unAvailableTime.hour();
        const startMinute = unAvailableTime.minute();
        if( selectedHour !== startHour ){
            return disabledMinutes;
        }
        for( let m=0; m <= startMinute; m+=5 ){
            disabledMinutes.push(m);
        }
        
        return disabledMinutes;
    };

    const handleEndTimeChange = debounce((time, timeString) => {
        if (postShiftObj?.start_time) {
            const startTime = dayjs(postShiftObj?.start_time, "h:mm A");
            const endTime = time;

            // Check if the start time and end time are the same
            if (startTime.isSame(endTime)) {
                toast.error("Start time and End time cannot be the same.");
                return;
            }

            // Check if the time difference is less than 1 hour
            const diffInHours = endTime.diff(startTime, "hour", true);
            if (diffInHours < 1) {
                toast.error("The time difference should be at least 1 hour.");
                return;
            }
        }

        // Update the end time
        setPostShiftObj((prev) => ({
            ...prev,
            end_time: timeString,
        }));
    }, 300);

    const renderShiftSelection = () => {
        const { addDates = [] } = postShiftObj;
        const lastDate = addDates.slice(-1)[0] ?? postShiftObj?.date;
        return (
            <>
                <Label className="shift-stepper-sub-title">Shift Details</Label>
                <div className="shift-stepper-field-wrap common-field-group">
                    <Label className="common-stepper-label">Date<sup style={{color:"#ff4d4f",fontSize:"0.7em"}}>*</sup></Label>
                    <DatePicker
                        className="common-datepicker common-antd-component"
                        style={{marginBottom:"10px"}}
                        value={
                            !!postShiftObj?.date && dayjs(postShiftObj?.date, "DD-MM-YYYY")
                        }
                        onChange={(date, dateString) => {
                            setPostShiftObj((prev) => ({
                                ...prev,
                                date: dateString,
                            }));
                            const startTimePicker = document.getElementById("shift-start-time-picker");
                            if( startTimePicker ){
                                startTimePicker.focus();
                            }
                        }}
                        disabledDate={disabledDate}
                        cellRender={cellRender}
                        timeString
                        format="DD-MM-YYYY"
                    />
                    {(errorsVisible&&!postShiftObj?.date)?(
                        <p style={{color:"#ff4d4f"}}>Please select a Shift Date</p>
                    ):null}
                    {(addDates.length && !shiftExists) ? (
                        addDates.map( (dt, i) =>
                            <DatePicker
                                key={i}
                                className="common-datepicker common-antd-component"
                                style={{marginBottom:"10px"}}
                                value={
                                    !!dt && dayjs(dt, "DD-MM-YYYY")
                                }
                                onChange={(date, dateString) => {
                                    let newAddDates = addDates;
                                    if( "" === dateString ){
                                        delete newAddDates[i];
                                    } else {
                                        newAddDates[i] = dateString;
                                    }
                                    setPostShiftObj((prev) => ({
                                        ...prev,
                                        addDates: newAddDates,
                                    }));
                                }}
                                disabledDate={disabledDate}
                                cellRender={cellRender}
                                timeString
                                format="DD-MM-YYYY"
                            />
                        )
                    ) : null}
                    {(!shiftExists) ? (
                        <div className="add-other-field">
                            <button
                                type="button"
                                disabled={(!lastDate||!postShiftObj?.date)}
                                className="add-field-btn btn btn-link"
                                onClick={e=>{
                                    // Get the next date
                                    const nextDay = dateNextDay(lastDate, "DD-MM-YYYY");
                                    let newAddDates = addDates;
                                    newAddDates.push(nextDay);
                                    setPostShiftObj((prev) => ({
                                        ...prev,
                                        addDates: newAddDates,
                                    }));
                                }}
                            >
                                Add <span className="add-icon">+</span>
                            </button>
                        </div>
                    ) : null}
                </div>
                <div className="shift-stepper-field-wrap common-field-group">
                    <Label className="common-stepper-label">Time<sup style={{color:"#ff4d4f",fontSize:"0.7em"}}>*</sup></Label>
                    <div className="d-flex">
                        {/* Start Time Picker */}
                        <TimePicker
                            id="shift-start-time-picker"
                            placeholder="Start time"
                            value={
                                postShiftObj?.start_time &&
                                dayjs(postShiftObj?.start_time, "h:mm A")
                            }
                            className="common-timepicker common-antd-component me-2"
                            use12Hours
                            minuteStep={5}
                            format="h:mm A"
                            onChange={(time, timeString) => {
                                handleStartTimeChange(time, timeString);
                            }}
                            onSelect={()=>{
                                // Prevent scrolling on TimePicker Columns
                                setTimeout( () => {
                                    const pickerCols = document.querySelectorAll(`.ant-picker-time-panel-column`);
                                    pickerCols.forEach( pickerCol => {
                                        pickerCol.scrollTo({ top: 0 });
                                    });
                                }, 1);
                            }}
                            needConfirm={false}
                            showNow={false}
                        />
                        {/* End Time Picker */}
                        <TimePicker
                            id="shift-end-time-picker"
                            placeholder="End time"
                            value={
                                postShiftObj?.end_time &&
                                dayjs(postShiftObj?.end_time, "h:mm A")
                            }
                            minuteStep={5}
                            className="common-timepicker common-antd-component"
                            use12Hours
                            format="h:mm A"
                            onChange={(time, timeString) =>
                                handleEndTimeChange(time, timeString)
                            }
                            disabledTime={(time) => ({
                                disabledHours: () => getDisabledEndHours(time),
                                disabledMinutes: (selectedHour) => getDisabledEndMinutes(time, selectedHour)
                            })}
                            needConfirm={false}
                            showNow={false}
                        />
                    </div>
                    {(errorsVisible&&(!postShiftObj.start_time || !postShiftObj.end_time))?(
                        <p style={{color:"#ff4d4f"}}>Please select a Start and End time</p>
                    ):null}
                </div>
                {availableLocation.length > 0 && (
                    <div className="shift-stepper-field-wrap common-field-group">
                        <Label className="common-stepper-label">Location</Label>
                        <Select
                            className="common-dropdown common-antd-component unpaid-hours-select"
                            // defaultValue={postShiftObj?.location?._id}
                            value={postShiftObj?.location}
                            placeholder="Select location"
                            optionFilterProp="children"
                            suffixIcon={<CustomArrowIcon />}
                            onChange={(e) => {
                                setPostShiftObj((prev) => ({
                                    ...prev,
                                    location: e,
                                }));
                            }}
                            allowClear={JSON.parse(localStorage.getItem("user"))?.role !== USER_ROLE.SUB_USER}
                            options={availableLocation}
                        />
                    </div>
                )}
            </>
        );
    };

    // Calculate time difference in minutes between start_time and end_time
    const calculateTimeDifference = (start, end) => {
        const startTime = dayjs(start, "h:mm A");
        const endTime = dayjs(end, "h:mm A");
        const diffInMinutes = endTime.diff(startTime, "minute");
        return diffInMinutes;
    };

    // Determine the maximum allowed unpaid minutes based on the selected time range
    const maxAllowedUnpaidMinutes = calculateTimeDifference(
        postShiftObj.start_time,
        postShiftObj.end_time
    );

    // Filter the unpaid hours list based on the maximum allowed minutes
    const filteredUnPaidHoursList = unPaidHoursList.filter((item) => {
        const minutes = parseInt(item.value.split("-")[0]);
        if( maxAllowedUnpaidMinutes >= 360 && 0 === minutes ){
            // Break enforced for shifts longer than 6hrs
            return false;
        }
        return minutes < maxAllowedUnpaidMinutes;
    });

    const renderUnpaidHours = () => {
        return (
            <>
                <Label className="shift-stepper-sub-title" style={{margin: "25px 0 10px 0"}}>Break (Unpaid Time)<sup style={{color:"#ff4d4f",fontSize:"0.7em"}}>*</sup></Label>
                <Select
                    className="common-dropdown common-antd-component unpaid-hours-select"
                    value={postShiftObj?.unpaid_hours}
                    placeholder="Select break length"
                    optionFilterProp="children"
                    suffixIcon={<CustomArrowIcon />}
                    onChange={(val) => {
                        setPostShiftObj((prev) => ({
                            ...prev,
                            unpaid_hours: val,
                        }));
                    }}
                    options={filteredUnPaidHoursList}
                />
                {(errorsVisible&&!postShiftObj?.unpaid_hours)?(
                    <p style={{color:"#ff4d4f"}}>Please select a Break Length</p>
                ):null}
            </>
        );
    };
    const renderHourlyRate = () => {
        return (
            <>
                <div className="common-radio-option post-shift-radio-option">
                    <Label className="shift-stepper-sub-title" style={{margin: "25px 0 10px 0"}}>Hourly Rate<sup style={{color:"#ff4d4f",fontSize:"0.7em"}}>*</sup></Label>
                    <div className="post-shift-option-wrapper">
                        <Input
                            placeholder="Hourly pay rate"
                            addonBefore="$"
                            className="antd-form-input-field"
                            onChange={(e) => {
                                const isValidRate = /^\d{0,4}(\.\d{0,2})?$/.test(
                                    e.target.value
                                );
                                if (isValidRate) {
                                    setPostShiftObj((prev) => ({
                                        ...prev,
                                        hourly_rate: e.target.value,
                                    }));
                                }
                            }}
                            value={postShiftObj?.hourly_rate}
                            type="number"
                        />
                    </div>

                    <Radio.Group
                        className="common-single-select"
                        onChange={(e, v) => {
                            setPostShiftObj((prev) => ({
                                ...prev,
                                hourly_rate_type: e.target.value,
                            }));
                        }}
                        value={postShiftObj?.hourly_rate_type}
                    >
                        <Space className="radio-wrapper" direction="vertical">
                            <Radio value="Fixed">Fixed </Radio>
                            <Radio value="Negotiable">Negotiable </Radio>
                        </Space>
                    </Radio.Group>
                </div>
                {(errorsVisible&&!postShiftObj?.hourly_rate)?(
                    <p style={{color:"#ff4d4f"}}>Please enter an Hourly Pay Rate</p>
                ):null}
            </>
        );
    };

    const steps = [
        {
            title: "Date & Time",
            content: renderShiftSelection(),
        },
        {
            title: "Rates & Allowances",
            content: [
                renderHourlyRate(),
                renderUnpaidHours()
            ],
        },
    ];

    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));

    const isCurrentStepEmpty = () => {
        switch (current) {
            case 0:
                return (
                    !postShiftObj.date ||
                    !postShiftObj.start_time ||
                    !postShiftObj.end_time
                );
            case 1:
                return !postShiftObj.hourly_rate || !postShiftObj.unpaid_hours;
            // case 2:
            //     return !postShiftObj.unpaid_hours;
            default:
                return false;
        }
    };

    return {
        openPostShiftModal,
        setOpenPostShiftModal,
        steps,
        items,
        current,
        skip,
        next,
        prev,
        showErrors,
        createPostShift,
        shiftOverview,
        unPaidHoursList,
        loading,
        isCurrentStepEmpty,
        resetStates,
        updatePostShift,
        initializeShiftData,
    };
};

export default usePostShiftHook;
